// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"7ae437ee","726":"50b152c0"}[chunkId] + ".chunk.js";
};